import { actionCreator } from 'utils';
import {
    CREATE_JOB_PALETTE,
    DELETE_COATING_OUT_JOB,
    CONFIRM_PALETTE,
    LOAD_COATING_OUT,
    LOAD_JOB_PALETTES_OUT,
    SET_IS_COATING_OUT_MODAL_VISIBLE,
    SET_CHECKED_JOB_RESULT_OUT,
    ADD_NEW_PALETTE_OUT,
    PRINT_PALETTE_OUT,
    SET_CHECKED_JOB_RESULT_RECORD_OUT,
    SHOW_ADD_NEW_PALETTE_POPUP_OUT,
    HIDE_ADD_NEW_PALETTE_POPUP_OUT,
    SET_IS_TOTAL_QUANTITY_SELECTED,
    SET_COATINGOUT_FILTERS,
    RESET_COATING_OUT_FILTERS,
    SET_JOB_PALETTES_OUT_FILTERS,
    RESET_JOB_PALETTES_OUT_FILTERS,
} from '../types/coatingOutTypes';

// L O A D   C O A T I N G   O U T
export function loadCoatingOut(loading) {
    return {
        type: LOAD_COATING_OUT,
        loading,
    };
}

export function loadCoatingOutRes(data) {
    return {
        type: actionCreator(LOAD_COATING_OUT, 'res'),
        data,
    };
}

export function loadCoatingOutErr() {
    return {
        type: actionCreator(LOAD_COATING_OUT, 'err'),
    };
}
// L O A D   C O A T I N G   O U T

// S E T   C O A T I N G   O U T   F I L T E R
export function setCoatingOutFilters(key, value) {
    return {
        type: SET_COATINGOUT_FILTERS,
        key,
        value,
    };
}

export function resetCoatingOutFilters() {
    return {
        type: RESET_COATING_OUT_FILTERS,
    };
}
// S E T   C O A T I N G   O U T   F I L T E R S

// L O A D   J O B   P A L E T T E S   O U T
export function loadJobPalettesOut() {
    return {
        type: LOAD_JOB_PALETTES_OUT,
    };
}

export function loadJobPalettesOutRes(data) {
    return {
        type: actionCreator(LOAD_JOB_PALETTES_OUT, 'res'),
        data,
    };
}

export function loadJobPalettesOutErr() {
    return {
        type: actionCreator(LOAD_JOB_PALETTES_OUT, 'err'),
    };
}
// L O A D   J O B   P A L E T T E S   O U T

// S E T   J O B   P A L E T T E S   O U T  F I L T E R
export function setJobPalettesOutFilters(key, value) {
    return {
        type: SET_JOB_PALETTES_OUT_FILTERS,
        key,
        value,
    };
}

export function resetJobPalettesOutFilters() {
    return {
        type: RESET_JOB_PALETTES_OUT_FILTERS,
    };
}
// S E T   J O B   P A L E T T E S   O U T  F I L T E R S

// C R E A T E   J O B   P A L E T T E
export function createJobPalette(data) {
    return {
        type: CREATE_JOB_PALETTE,
        data,
    };
}

export function createJobPaletteRes(success) {
    return {
        type: actionCreator(CREATE_JOB_PALETTE, 'res'),
        success,
    };
}

export function createJobPaletteErr(error) {
    return {
        type: actionCreator(CREATE_JOB_PALETTE, 'err'),
        error,
    };
}
// C R E A T E   J O B   P A L E T T E

// D E L E T E   C O A T I N G   O U T   J O B
export function deleteCoatingOutJob(data) {
    return {
        type: DELETE_COATING_OUT_JOB,
        data,
    };
}

export function deleteCoatingOutJobRes(success) {
    return {
        type: actionCreator(DELETE_COATING_OUT_JOB, 'res'),
        success,
    };
}

export function deleteCoatingOutJobErr(error) {
    return {
        type: actionCreator(DELETE_COATING_OUT_JOB, 'err'),
        error,
    };
}
// D E L E T E   C O A T I N G   O U T   J O B

// C O N F I R M   P A L E T T E
export function confirmPalette(machineId, jobPalettesIds, paletteNumber, paletteId) {
    return {
        type: CONFIRM_PALETTE,
        machineId,
        jobPalettesIds,
        paletteNumber,
        paletteId,
    };
}

export function confirmPaletteRes(payload) {
    return {
        type: actionCreator(CONFIRM_PALETTE, 'res'),
        payload,
    };
}

export function confirmPaletteErr(error) {
    return {
        type: actionCreator(CONFIRM_PALETTE, 'err'),
        error,
    };
}
// C O N F I R M   P A L E T T E

// A D D   N E W   P A L E T T E   O U T
export function addNewPaletteOut(data) {
    return {
        type: ADD_NEW_PALETTE_OUT,
        data,
    };
}

export function addNewPaletteOutRes() {
    return {
        type: actionCreator(ADD_NEW_PALETTE_OUT, 'res'),
    };
}

export function addNewPaletteOutErr() {
    return {
        type: actionCreator(ADD_NEW_PALETTE_OUT, 'err'),
    };
}
// A D D   N E W   P A L E T T E   O U T

// P R I N T   P A L E T T E   O U T
export function printPaletteOut(data) {
    return {
        type: PRINT_PALETTE_OUT,
        data,
    };
}

export function printPaletteOutRes() {
    return {
        type: actionCreator(PRINT_PALETTE_OUT, 'res'),
    };
}

export function printPaletteOutErr() {
    return {
        type: actionCreator(PRINT_PALETTE_OUT, 'err'),
    };
}
// P R I N T   P A L E T T E   O U T

// S E T   C H E C K E D   J O B   R E S U L T   O U T
export function setCheckedJobResultOut(ids) {
    return {
        type: SET_CHECKED_JOB_RESULT_OUT,
        ids,
    };
}
// S E T   C H E C K E D   J O B   R E S U L T   O U T

// S E T   C H E C K E D   J O B   R E S U L T   R E C O R D   O U T
export function setCheckedJobResultRecordOut(data) {
    return {
        type: SET_CHECKED_JOB_RESULT_RECORD_OUT,
        data,
    };
}
// S E T   C H E C K E D   J O B   R E S U L T   R E C O R D   O U T

// A D D   N E W  P A L E T T E   P O P U P   V I S I B I L I T Y   O U T
export function showAddNewPalettePopupOut() {
    return {
        type: SHOW_ADD_NEW_PALETTE_POPUP_OUT,
    };
}

export function hideAddNewPalettePopupOut() {
    return {
        type: HIDE_ADD_NEW_PALETTE_POPUP_OUT,
    };
}
// A D D   N E W  P A L E T T E   P O P U P   V I S I B I L I T Y   O U T
// S E T   I S   C O A T I N G   O U T   M O D A L   V I S I B L E
export function setIsCoatingOutModalVisible(data) {
    return {
        type: SET_IS_COATING_OUT_MODAL_VISIBLE,
        data,
    };
}
// S E T   I S   C O A T I N G   O U T   M O D A L   V I S I B L E

// S E T   I S   T O T A L   Q U A N T I T Y   S E L E C T E D
export function setIsTotalQuantitySelected(data) {
    return {
        type: SET_IS_TOTAL_QUANTITY_SELECTED,
        data,
    };
}
// S E T   I S   T O T A L   Q U A N T I T Y   S E L E C T E D
